<template>
  <Radar
    :chart-options="chartOptions"
    :chart-data="chartData"
    :styles="styles"
    :width="width"
    :height="height" />
</template>

<script>
import { Radar } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  RadialLinearScale,
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  PointElement,
  RadialLinearScale,
  LineElement
)

export default {
  name: 'RadarChart',
  components: {
    Radar,
  },
  props: {
    width: {
      type: [Number, String],
      default: null,
    },
    height: {
      type: [Number, String],
      default: null,
    },
    labels: {
      type: Array,
      required: true
    },
    datasets: {
      type: Array,
      required: true
    },
    displayLegend: {
      type: Boolean,
      default: false,
    },
    padding: {
      type: Object,
      default: () => {}
    },
    styles: {
      type: Object,
      default: () => {}
    },
    devicePixelRatio: {
      type: Number,
      default: null,
    },
  },
  computed: {
    chartData() {
      return {
        labels: this.labels,
        datasets: this.datasets,
      }
    },
    chartOptions() {
      return {
        layout: {
          padding: this.padding
        },
        scales: {
          r: {
            grid: {
              color: '#BDBDBD'
            },
            angleLines: {
              color: '#BDBDBD'
            },
            min: 0,
            ticks: {
              stepSize: 1
            },
            pointLabels: {
              font: {
                size: 11
              }
            }
          }
        },
        plugins: {
          legend: {
            labels: {
              boxWidth: 20,
              boxHeight: 1,
            },
            display: this.displayLegend,
            position: 'chartArea',
            align: 'start'
          }
        },
        responsive: true,
        devicePixelRatio: this.devicePixelRatio,
        maintainAspectRatio: false,
        onClick: this.onClickChart
      }
    },
  },
  methods: {
    onClickChart(event, chartElements) {
      return this.$emit('click', event, chartElements)
    }
  }
}
</script>
